import { BrowsingButton, RightNowButton, MeetupButton, ChattingButton, RomanceButton } from '@components/nearby/StatusSelectButtons'
import { colors, fontSize, size } from '@styles/theme'
import styled from '@emotion/styled'
import { TextField, Divider, Select, MenuItem } from '@mui/material' 
import { PiArrowFatDownFill, PiArrowFatUpFill, PiArrowRightBold, PiArrowsDownUpBold, PiArrowsHorizontalBold, PiCarProfileFill, PiHouseLineFill } from 'react-icons/pi'
import { ActionButton, BottomButtonGroup } from '@components/auth/landing/LandingElements'

const MetaContainer = styled.div`
  height: 100%;
  width: 100%;
  padding-top: ${size(1)};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const DisplayBackground = styled.div`
  display: flex;
  border-radius: 100px;
  margin: 0 ${size(1)} ${size(1)} ${size(1)};
  padding: ${size(0.75)};
  background-color: rgba(255,255,255,0.1);
`

const StyledDivider = styled(Divider)`
  border-color: grey !important;
  color: grey;
  font-size: ${fontSize('sm')};
  margin: ${size(1)};

  &::before {
    border-color: grey !important;
  }
  &::after {
    border-color: grey !important;
  }
`

const InputLabel = styled.label`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin: ${size(1)};
`

const LabelText = styled.span`
  padding: 0 0 ${size(0.5)} ${size(1)};
  font-size: ${fontSize('sm')};
`

const StyledTextField = styled(TextField)`
  width: 100%;
  background-color: rgba(20,20,20,0.9);
  box-shadow: 0 2px 4px rgba(0,0,0,0.25);
  backdrop-filter: blur(3px);
  
  & textarea {
    color: white !important;
  }
  & label {
    color: white !important;
  }
  & .MuiOutlinedInput-root {
    & fieldset {
      border-color: grey !important;
      border-radius: 15px;
    }
  }
`

const OptionWrapper = styled.div`
  display: flex !important;
  align-items: center !important;
  padding-right: 0;
  font-weight: 500;
`

const inputBackgroundStyles = {
  backgroundColor: 'rgba(20,20,20,0.9)',
  boxShadow: '0 2px 4px rgba(0,0,0,0.25)',
  backdropFilter: 'blur(3px)',
}

const StyledSelect = ({ wrapperStyles, children, ...rest }) => {
  return (
    <Select
      sx={{
        '.MuiSelect-select': {
          paddingLeft: `16px !important`,
          paddingRight: `16px !important`,
          paddingTop: '0 !important',
          paddingBottom: '0 !important',
        },
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'transparent',
        },
        '.MuiSvgIcon-root ': {
          color: 'grey',
        },
        borderRadius: '15px',
        // backgroundColor: 'rgba(20,20,20,0.9)',
        color: 'white',
        border: '1px solid grey',
        height: size(4),
        fontSize: fontSize('sm'),
        backgroundColor: 'rgba(20,20,20,0.9)',
        boxShadow: '0 2px 4px rgba(0,0,0,0.25)',
        backdropFilter: 'blur(3px)',
        ...wrapperStyles,
      }}
      {...rest}>
      {children}
    </Select>
  )
}

const statusButton = (status) => ({
  browsing: BrowsingButton,
  right_now: RightNowButton,
  meetup: MeetupButton,
  chatting: ChattingButton,
  romance: RomanceButton,
}[status])

const NewStatusDisplay = ({ status }) => {
  const Component = statusButton(status)
  return  (
    <DisplayBackground>
      <Component
        buttonStyles={{ margin: 0 }}
        isDisabled
        hideArrow
        isNew
      />
    </DisplayBackground>
  )
}

const StatusContentMeta = ({ newStatus, metaState, handleChange, isLoading, submitTempStatus }) => {

  const renderRightNowOptions = () => (
    <>
      <InputLabel>
        <LabelText>
          Position you want (now)
        </LabelText>
        <StyledSelect
          size='small'
          name='position'
          displayEmpty
          onChange={handleChange}
          value={metaState?.position || ''}
          wrapperStyles={{ height: size(5) }}>
          <MenuItem value=''>
            <OptionWrapper>
              None
            </OptionWrapper>
          </MenuItem>
          <MenuItem value='top'>
            <OptionWrapper>
              <PiArrowFatUpFill size={size(2)} />
              &nbsp;
              Top
            </OptionWrapper>
          </MenuItem>
          <MenuItem value='bottom'>
            <OptionWrapper>
              <PiArrowFatDownFill size={size(2)} />
              &nbsp;
              Bottom
            </OptionWrapper>
          </MenuItem>
          <MenuItem value='verse'>
            <OptionWrapper>
              <PiArrowsDownUpBold size={size(2)} />
              &nbsp;
              Verse
            </OptionWrapper>
          </MenuItem>
          <MenuItem value='side'>
            <OptionWrapper>
              <PiArrowsHorizontalBold size={size(2)} />
              &nbsp;
              Side
            </OptionWrapper>
          </MenuItem>
        </StyledSelect>
      </InputLabel>
      <InputLabel>
        <LabelText>
          Hosting availability (now)
        </LabelText>
        <StyledSelect
          size='small'
          name='hosting'
          displayEmpty
          onChange={handleChange}
          value={metaState?.hosting || ''}
          wrapperStyles={{ height: size(5) }}>
          <MenuItem value=''>
            <OptionWrapper>
              None
            </OptionWrapper>
          </MenuItem>
          <MenuItem value='hosting'>
            <OptionWrapper>
              <PiHouseLineFill size={size(2)} />
              &nbsp;
              Hosting
            </OptionWrapper>
          </MenuItem>
          <MenuItem value='traveling'>
            <OptionWrapper>
              <PiCarProfileFill size={size(2)} />
              &nbsp;
              Traveling
            </OptionWrapper>
          </MenuItem>
          <MenuItem value='host_or_travel'>
            <OptionWrapper>
              <img src='https://mandrake-app.b-cdn.net/dev/application/icons/host_or_travel.svg' width={size(2)} style={{ width: size(2) }} />
              &nbsp;
              Host or Travel
            </OptionWrapper>
          </MenuItem>
        </StyledSelect>
      </InputLabel>
    </>
  )

  return (
    <MetaContainer>
      <TopContainer>        
        <NewStatusDisplay status={newStatus} />
        <StyledDivider>More Options</StyledDivider>
        <InputLabel>
          <LabelText>
            Update tagline?
          </LabelText>
          <StyledTextField
            size='small'
            multiline
            rows={2}
            name='tagline'
            onChange={handleChange}
            placeholder='What are you looking for?'
            defaultValue={metaState?.tagline}
          />
        </InputLabel>
        {newStatus === 'right_now' && renderRightNowOptions()}
      </TopContainer>
      <BottomButtonGroup style={{ position: 'relative' }}>
        <ActionButton
          disabled={isLoading}
          variant='contained'
          onClick={submitTempStatus}
          style={{ background: colors.statusColors.right_now('primary') }}
          size='large'
          type='submit'>
          {isLoading
            ? 'Loading...'
            : <>Submit&nbsp;<PiArrowRightBold /></>
          }
        </ActionButton>
      </BottomButtonGroup>
    </MetaContainer>
  )
}

export default StatusContentMeta
